import { useStepper } from './StepperManager';

export const useStepperSelectors = () => {
    const { selectors } = useStepper();

    return selectors;
};
